module.exports = __webpack_public_path__ + "static/media/add_member.867f677f.svg";